export default {
  primary: "#8067b3",
  secondary: "#44b8da",
  success: "#34a853",
  warning: "#fbbf0f",
  danger: "#ea4335",
  bodyBg: "#eaf0fc",

  sidebarBg: "#f5f5f5"
};



// WEBPACK FOOTER //
// ./src/colors.js